import { ComponentMap } from '@cinch-nx/data-storyblok'
import {
  NextImage,
  RichText,
  IconWithText,
  FinanceOfferCardBlock,
} from '../atom-blocks'
import { FinanceRepresentativeExample } from '@cinch-nx/ui-finance'

export const atomStoryblokComponents: ComponentMap = {
  FinanceOfferCard: FinanceOfferCardBlock,
  FinanceRepresentativeExample,
  Image_v2: NextImage,
  RichText,
  IconWithText,
}
